import React, { useState, useEffect } from 'react';
import { Button, DropdownButton, Dropdown, Image } from 'react-bootstrap';
import { BsFillCheckCircleFill } from 'react-icons/bs';

import iconUserChat from '../../assets/icon/userChat.svg';

import { useUserStatus } from '../../hooks/userStatus';
import { useMessage } from '../../hooks/message';

import DataChatUser from '../../interfaces/IDataChatUser';
import Users from '../../interfaces/IUsers';
import { getInitials, getStatusIcon } from '../../services/function';
import { userStatus } from '../../enums/userStatus';

const colorStatus = new Array<string>(
  '#fff',
  '#198754',
  '#ffc107',
  '#dc3545',
  '#000'
);

const ListUserStatus: React.FC<any> = ({
  usuario,
  setUsuario,
  users,
  msgDefaultWithoutUser,
}: {
  usuario: number | null;
  setUsuario: React.Dispatch<React.SetStateAction<number | null>>;
  users: Users[];
  msgDefaultWithoutUser: string;
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ left: 0, top: 0 });
  const [dadosUsuario, setdadosUsuario] = useState<Users>({} as Users);
  const [userAdmin, setUserAdmin] = useState(false);
  const { disconnectUser } = useUserStatus();
  const { addChatGroup } = useMessage();

  const handleRightClick = (event: any, key: any): void => {
    event.preventDefault();
    if (event.button === 2) {
      setShowMenu(true);
      setMenuPosition({ left: event.clientX, top: event.clientY });
      setdadosUsuario(key);
    }
  };

  const addChat = (seqGrupo: number, seqUsuario: number): void => {
    const chat: DataChatUser = {
      seqGrupoConversa: 0,
      seqGrupo,
      nomeGrupo: '',
      user: '',
      seqUsuario,
      chatHistorico: 'N',
    };

    addChatGroup(chat);
  };

  useEffect(() => {
    setUserAdmin(localStorage.getItem('@LiveChat:administrador') === 'S');
  }, []);

  useEffect(() => {
    const bnt = document.getElementById('dropdown-basic-button');
    if (bnt !== null) {
      bnt.tabIndex = 0;
      bnt.focus();
    }
  }, [showMenu]);

  const handleClickItem = (): void => {
    disconnectUser(dadosUsuario.seqUsuario);
    setShowMenu(false);
  };

  const handleHideMenu = (): void => {
    setShowMenu(false);
  };

  return (
    <div className="d-flex flex-column">
      {users.length >= 1 ? (
        <div>
          <ul className="border border-2 rounded-2 p-1 shadow bg-light">
            {users.length > 0 &&
              users
                .sort((a: Users, b: Users) =>
                  a.nomeUsuario.localeCompare(b.nomeUsuario)
                )
                .map((dataUser: Users) => (
                  <div
                    key={dataUser.seqUsuario}
                    onContextMenu={(e) => handleRightClick(e, dataUser)}
                    onMouseDown={handleHideMenu}
                    role="button"
                    onDoubleClick={() => addChat(0, dataUser.seqUsuario)}
                    onClick={() => setUsuario(dataUser.seqUsuario)}
                    onKeyDown={() => setUsuario(dataUser.seqUsuario)}
                    tabIndex={0}
                  >
                    <li
                      key={dataUser.seqUsuario}
                      className="d-flex flex-row align-items-center"
                    >
                      <div
                        className="d-flex align-items-center justify-content-between w-100 me-2"
                        style={{
                          backgroundColor: `${
                            dataUser.seqUsuario === usuario ? '#d9d9d9' : ''
                          }`,
                        }}
                      >
                        <div className="d-flex position-relative align-items-center mb-1">
                          <div
                            style={{
                              width: '2.5rem',
                              height: '2.5rem',
                              marginTop: '0.2rem',
                              marginLeft: '0.5rem',
                              backgroundColor:
                                dataUser.cor === '' || !dataUser.cor
                                  ? '#616161'
                                  : dataUser.cor,
                              borderRadius: '0.6875rem',
                            }}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <span
                              style={{
                                color: '#fff',
                                fontSize: '1.25rem',
                                textAlign: 'center',
                                fontWeight: '600',
                                wordWrap: 'break-word',
                              }}
                            >
                              {getInitials(dataUser.nomeUsuario)}
                            </span>
                          </div>

                          {dataUser.status !== userStatus.Invisivel && (
                            <Image
                              className="position-absolute"
                              style={{
                                top: '1.8rem',
                                left: '2.4rem',
                                height: '1.25rem',
                                width: '1.25rem',
                              }}
                              src={getStatusIcon(dataUser.status)}
                              alt="Online"
                            />
                          )}
                          <span
                            style={{
                              fontSize: '1.25rem',
                              marginLeft: '0.6rem',
                            }}
                          >
                            {dataUser.nomeUsuario}
                          </span>
                        </div>
                        <Button
                          className="p-0 m-0"
                          style={{
                            height: '2.1rem',
                            width: '2.1rem',
                          }}
                          onClick={() => addChat(0, dataUser.seqUsuario)}
                        >
                          <img
                            src={iconUserChat}
                            style={{
                              height: '1.8rem',
                              width: '1.8rem',
                            }}
                            alt="chat"
                          />
                        </Button>
                      </div>
                    </li>
                  </div>
                ))}
          </ul>
        </div>
      ) : (
        <span className="w-100 text-center fw-bold text-secondary">
          {msgDefaultWithoutUser === undefined || msgDefaultWithoutUser === ''
            ? 'Não há usuários on-line no momento.'
            : msgDefaultWithoutUser}
        </span>
      )}
    </div>
  );
};

export default ListUserStatus;
